module.exports = __webpack_public_path__ + "static/img/3.cc2d173c.png";